import { render } from "./language-selector.vue?vue&type=template&id=fb7be8ea&ts=true"
import script from "./language-selector.vue?vue&type=script&lang=ts"
export * from "./language-selector.vue?vue&type=script&lang=ts"

import "./language-selector.vue?vue&type=style&index=0&id=fb7be8ea&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__